import { LinkOpenInTab } from '@mediashop/base/pattern/atom/LinkOpenInTab';
import classNames from 'classnames';
import { useLocation } from 'react-router';
import { getIsChildNavItemActive } from '../../../helper';
import { BurgerMenuSubNavigationProps } from './index';

const componentName = 'burger-menu-sub-navigation';

const BurgerMenuSubNavigation = ({ closeBurgerMenu, isOpen, subNavigation }: BurgerMenuSubNavigationProps) => {
    const location = useLocation();

    const filteredSubNavigation = subNavigation.filter((item) => !item.hide);

    return (
        <ul
            className={classNames(componentName, {
                [`${componentName}--open`]: isOpen,
            })}
        >
            {filteredSubNavigation.map((childItem) => (
                <li
                    key={childItem.link.text}
                    className={classNames(`${componentName}__item`, {
                        [`${componentName}__item--headline`]: childItem.isHeadline,
                        [`${componentName}__item--indented`]: !childItem.isHeadline,
                    })}
                >
                    <LinkOpenInTab
                        className={`${componentName}__link`}
                        tab={childItem.tab}
                        link={childItem.link}
                        isActive={getIsChildNavItemActive(childItem.link.reference, location)}
                        onClick={closeBurgerMenu}
                    >
                        {childItem.link.text}
                    </LinkOpenInTab>
                </li>
            ))}
        </ul>
    );
};

export default BurgerMenuSubNavigation;
